
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqs6dGJUmVSxjPclIxtzYKmNxuhhbdHXDRzWQQq0ahg9HUMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/faqs.vue?macro=true";
import { default as indexwrRnRT82e4z_jSDL9Hs44e3b_jvbNLo5ZdfSBLDIzwoMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/index.vue?macro=true";
import { default as linksVKQyec2lTRgonajgTWKqLNFBq94xX2F90BiKA8EPk8UMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/links.vue?macro=true";
import { default as musicAzqrpvwo47Qo9UlznHx9bJVn2k_fLjd9ULN_rg1wLzgMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/music.vue?macro=true";
import { default as venueuy2VoE_wpYdIef4wMY4TTg2YDIpw_zixpoh24kyBHdAMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/venue.vue?macro=true";
import { default as signupNgduiF4TizXYMtOd6jAnjhkRmgR56ElGSqXS1yczliUMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/signup.vue?macro=true";
import { default as contactm7_IrYBO_9ks4FgA5_HqJAoclKT4fvZ4QaYPnyiwUFUMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/contact.vue?macro=true";
import { default as cookiescoGcAL_KDDIFtkBdYgwqZx0Kn8L7OjLUspaxdCkeNVQMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/cookies.vue?macro=true";
import { default as pgh1dYV_2DOrspnXjSSpmXoSYncsF1UVlitj9S4LYRRw65IMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/ig/pgh1.vue?macro=true";
import { default as editcj8X0jE_8KwuRR23HvbkwXmP1azAieL6EMW1jqAco_kMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/me/edit.vue?macro=true";
import { default as privacyJMDlOSDuLTF47_XnWmSSKqlayYaMN8kkxrAjxb9fxrUMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/privacy.vue?macro=true";
import { default as indexwqsCibZV_GvEBQB4SoSBGale6l12QF2cv_eiFfz9bskMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/ig/index.vue?macro=true";
import { default as indexOzf3HBIyc8vf85925dCr32LSeeVixI6TgvhXDzwiKe8Meta } from "/codebuild/output/src4098491044/src/nuxt/pages/me/index.vue?macro=true";
import { default as indexGZWaKaRWLA6PH4cAZRUqkXO9MScHjcgPyp4i1bzJxPMMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/blog/index.vue?macro=true";
import { default as event_45termsSlJ__emag_WQxTihhUayfedeGg8AN7RXw91pKWpVMgAMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/event-terms.vue?macro=true";
import { default as _91passcode_93TEbuYj8_AsZ1CPQchDEY2_1b7cpEoy8Zkchd8ylEfsYMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/login/index/[passcode].vue?macro=true";
import { default as indexpvZU0Ql8DISJtBwORoAN0oJuaFTvw_sIFflbdhfdqmsMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/login/index.vue?macro=true";
import { default as indexrwolx893pah9tzNvaHUNOHh5MH9QfJ_qAQdoJU__TDgMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/events/index.vue?macro=true";
import { default as website_45termsc1KfdoqcmRezvCFXJxZVmL9snCJNGkpvd32OgkYejoAMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/website-terms.vue?macro=true";
import { default as _91token_93EAMpC_CFWk693n16my_n78cH_iXDrm7WVF61J3UG_ikMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/messages/index/[idThread]/[token].vue?macro=true";
import { default as _91idThread_93C7ndPbvwBnSHb0nDicClmBkVwLzntjjANw6hnif8OCYMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/messages/index/[idThread].vue?macro=true";
import { default as indexivTu0RbWRDNowZ2RJE7iDARyEFFCfCErXhfFLHKZhJMMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/messages/index.vue?macro=true";
import { default as indexmGE2xMWvWRfrEaYVPidnGqDt8wc6aDzPgMgf3jRNyb4Meta } from "/codebuild/output/src4098491044/src/nuxt/pages/subscribe/index.vue?macro=true";
import { default as indexgcD_u0dzYiOxRRguYIxbEKpaW8BaIGqszMquIos1U_AMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/login-code/index.vue?macro=true";
import { default as notificationsC7MXwoF2UpjL_hSWITewBzGlrI_mcZoeywuaT4wfgDsMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/me/notifications.vue?macro=true";
import { default as _91eventSlug_93YuNMcXyul7V7qSHfyhHkWIF3CKrxiQnVQooLAEweujcMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/events/[eventSlug].vue?macro=true";
import { default as _91postSlug_93NAm5dkekblp7L51wK_kzgoXAg83edg1sL3MT5S1cnU4Meta } from "/codebuild/output/src4098491044/src/nuxt/pages/blog/posts/[postSlug].vue?macro=true";
import { default as indexcdtdFhKlJg2j2qnpXSWdeuYStpivv6CI_NsLF0ax4GAMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/me/subscriptions/index.vue?macro=true";
import { default as _91token_93p6W5_ebixW4DXokyY6qDpgiNYYC59bNFJkOjfvSDbwsMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/unsubscribe/[email]/[token].vue?macro=true";
import { default as _91idSubscription_93CVsp4Qkfs0swc4Kn2Nh9R8wGXe_oOU_C5UMrAgoPc7cMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/me/subscriptions/[idSubscription].vue?macro=true";
import { default as _91subscriptionProductSlug_93PqJhRJSrpumjyMootlIZm4DHKI9eFVGnuBcN_R9j0KIMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/subscribe/[subscriptionProductSlug].vue?macro=true";
import { default as _91token_93IIaC36XaIG06RMvZY5o9uGXa3SChgdbvh71ubReAeEUMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/unsubscribe-mailers/[email]/[token].vue?macro=true";
import { default as registry_45event_45survival_45guidedKg9_df62FO7B2PHD_275JYZqJnmf6b4otPju9qOhukMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/blog/posts/registry-event-survival-guide.vue?macro=true";
import { default as the_45dangers_45of_45giving_45feedback9wHxJxE2ykBxVMEjUgvYRF6KHl6oXgM6xXy_zIqeBe4Meta } from "/codebuild/output/src4098491044/src/nuxt/pages/blog/posts/the-dangers-of-giving-feedback.vue?macro=true";
import { default as the_45renegade_45of_45the_45swing_45family_1_VDr048KUj0L10eYQhyEVUH0NFBVcbRAmMGZCeekUMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/blog/posts/the-renegade-of-the-swing-family.vue?macro=true";
import { default as what_45to_45expect_45at_45your_45first_45class3JFm50j_ASe1YPo5Tjl3_8a6vQ813uKp_Lm00zQGRxYMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/blog/posts/what-to-expect-at-your-first-class.vue?macro=true";
import { default as wsdc_45registry_45events_45we_45are_45attendingHyJpZNf8mWiWlpoXs3LanuO1sEUzAoACGcg_6cDo62MMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/blog/posts/wsdc-registry-events-we-are-attending.vue?macro=true";
import { default as where_45can_45i_45west_45coast_45swing_45in_45yorkshireukBthUA26fgSVlyOKp1J0CGa1Z2a3ZV5YUCgxeD6IGwMeta } from "/codebuild/output/src4098491044/src/nuxt/pages/blog/posts/where-can-i-west-coast-swing-in-yorkshire.vue?macro=true";
export default [
  {
    name: "faqs",
    path: "/faqs",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/faqs.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/index.vue")
  },
  {
    name: "links",
    path: "/links",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/links.vue")
  },
  {
    name: "music",
    path: "/music",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/music.vue")
  },
  {
    name: "venue",
    path: "/venue",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/venue.vue")
  },
  {
    name: "signup",
    path: "/signup",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/signup.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/contact.vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/cookies.vue")
  },
  {
    name: "ig-pgh1",
    path: "/ig/pgh1",
    meta: pgh1dYV_2DOrspnXjSSpmXoSYncsF1UVlitj9S4LYRRw65IMeta || {},
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/ig/pgh1.vue")
  },
  {
    name: "me-edit",
    path: "/me/edit",
    meta: editcj8X0jE_8KwuRR23HvbkwXmP1azAieL6EMW1jqAco_kMeta || {},
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/me/edit.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/privacy.vue")
  },
  {
    name: "ig",
    path: "/ig",
    meta: indexwqsCibZV_GvEBQB4SoSBGale6l12QF2cv_eiFfz9bskMeta || {},
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/ig/index.vue")
  },
  {
    name: "me",
    path: "/me",
    meta: indexOzf3HBIyc8vf85925dCr32LSeeVixI6TgvhXDzwiKe8Meta || {},
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/me/index.vue")
  },
  {
    name: "blog",
    path: "/blog",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/blog/index.vue")
  },
  {
    name: "event-terms",
    path: "/event-terms",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/event-terms.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/login/index.vue"),
    children: [
  {
    name: "login-index-passcode",
    path: ":passcode()",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/login/index/[passcode].vue")
  }
]
  },
  {
    name: "events",
    path: "/events",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/events/index.vue")
  },
  {
    name: "website-terms",
    path: "/website-terms",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/website-terms.vue")
  },
  {
    name: "messages",
    path: "/messages",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/messages/index.vue"),
    children: [
  {
    name: "messages-index-idThread",
    path: ":idThread()",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/messages/index/[idThread].vue"),
    children: [
  {
    name: "messages-index-idThread-token",
    path: ":token()",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/messages/index/[idThread]/[token].vue")
  }
]
  }
]
  },
  {
    name: "subscribe",
    path: "/subscribe",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/subscribe/index.vue")
  },
  {
    name: "login-code",
    path: "/login-code",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/login-code/index.vue")
  },
  {
    name: "me-notifications",
    path: "/me/notifications",
    meta: notificationsC7MXwoF2UpjL_hSWITewBzGlrI_mcZoeywuaT4wfgDsMeta || {},
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/me/notifications.vue")
  },
  {
    name: "events-eventSlug",
    path: "/events/:eventSlug()",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/events/[eventSlug].vue")
  },
  {
    name: "blog-posts-postSlug",
    path: "/blog/posts/:postSlug()",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/blog/posts/[postSlug].vue")
  },
  {
    name: "me-subscriptions",
    path: "/me/subscriptions",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/me/subscriptions/index.vue")
  },
  {
    name: "unsubscribe-email-token",
    path: "/unsubscribe/:email()/:token()",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/unsubscribe/[email]/[token].vue")
  },
  {
    name: "me-subscriptions-idSubscription",
    path: "/me/subscriptions/:idSubscription()",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/me/subscriptions/[idSubscription].vue")
  },
  {
    name: "subscribe-subscriptionProductSlug",
    path: "/subscribe/:subscriptionProductSlug()",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/subscribe/[subscriptionProductSlug].vue")
  },
  {
    name: "unsubscribe-mailers-email-token",
    path: "/unsubscribe-mailers/:email()/:token()",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/unsubscribe-mailers/[email]/[token].vue")
  },
  {
    name: "blog-posts-registry-event-survival-guide",
    path: "/blog/posts/registry-event-survival-guide",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/blog/posts/registry-event-survival-guide.vue")
  },
  {
    name: "blog-posts-the-dangers-of-giving-feedback",
    path: "/blog/posts/the-dangers-of-giving-feedback",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/blog/posts/the-dangers-of-giving-feedback.vue")
  },
  {
    name: "blog-posts-the-renegade-of-the-swing-family",
    path: "/blog/posts/the-renegade-of-the-swing-family",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/blog/posts/the-renegade-of-the-swing-family.vue")
  },
  {
    name: "blog-posts-what-to-expect-at-your-first-class",
    path: "/blog/posts/what-to-expect-at-your-first-class",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/blog/posts/what-to-expect-at-your-first-class.vue")
  },
  {
    name: "blog-posts-wsdc-registry-events-we-are-attending",
    path: "/blog/posts/wsdc-registry-events-we-are-attending",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/blog/posts/wsdc-registry-events-we-are-attending.vue")
  },
  {
    name: "blog-posts-where-can-i-west-coast-swing-in-yorkshire",
    path: "/blog/posts/where-can-i-west-coast-swing-in-yorkshire",
    component: () => import("/codebuild/output/src4098491044/src/nuxt/pages/blog/posts/where-can-i-west-coast-swing-in-yorkshire.vue")
  }
]